// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".Option_option__2r4x{border-bottom:1px solid #ddd}.Option_option__2r4x:last-child{border-bottom:none}.Option_optionV2__2Dwc{display:flex;align-items:center}.Option_icon__Wvck{margin-right:10px}", "",{"version":3,"sources":["node_modules/@sinclair-digital/sbg-storyline-components/src/components/forms/Option/Option.css"],"names":[],"mappings":"AAAA,qBACE,4BAAA,CAGF,gCACE,kBAAA,CAGF,uBACE,YAAA,CACA,kBAAA,CAGF,mBACE,iBAAA","file":"Option.css","sourcesContent":[".option {\n  border-bottom: 1px solid #ddd;\n}\n\n.option:last-child {\n  border-bottom: none;\n}\n\n.optionV2 {\n  display: flex;\n  align-items: center;\n}\n\n.icon {\n  margin-right: 10px;\n}\n"]}]);
// Exports
exports.locals = {
	"option": "Option_option__2r4x",
	"optionV2": "Option_optionV2__2Dwc",
	"icon": "Option_icon__Wvck"
};
module.exports = exports;
